import { RecordValue } from '@coveo/bueno';
import { requiredEmptyAllowedString, requiredNonEmptyString, validatePayload, } from '../../utils/validate-payload.js';
export const uniqueIdentifierPayloadDefinition = () => new RecordValue({
    values: {
        questionAnswerId: requiredNonEmptyString,
    },
    options: { required: true },
});
export const inlineLinkPayloadDefinition = () => new RecordValue({
    values: {
        linkText: requiredEmptyAllowedString,
        linkURL: requiredEmptyAllowedString,
    },
    options: { required: true },
});
export function validateQuestionAnsweringActionCreatorPayload(payload) {
    return validatePayload(payload, uniqueIdentifierPayloadDefinition());
}
